var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nlt"},[_c('div',{staticClass:"time_box"},[_c('data-type',{ref:"datatype",attrs:{"timeType":_vm.timeType,"showExporyytn":false,"timeInterval":_vm.toTime,"alarnclass":_vm.alarnclass},on:{"getData":_vm.getTreeNodes}})],1),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"SankeyBox"},[_c('div',{attrs:{"id":"Sankey"}})])
}]

export { render, staticRenderFns }